
export function processAvatarUrl (avatar: string | undefined): string | null {
    if (!avatar) return null;

    // Prepend media domain
    let mediaPaths: string[] = ["production/", "local/", "staging/", "tmp/"];
    if (mediaPaths.some(path => avatar.startsWith(path))) {
        return `${import.meta.env.VITE_MEDIA_HOST}/${avatar}`;
    }

    return avatar;
}